import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
const scrollBarVariants = cva(
  "flex touch-none p-px transition-colors select-none",
  {
    variants: {
      orientation: {
        vertical: "h-full w-2.5 border-l border-l-transparent",
        horizontal: "h-2.5 flex-col border-t border-t-transparent"
      }
    },
    defaultVariants: {
      orientation: "vertical"
    }
  }
);
export {
  scrollBarVariants
};
//# sourceMappingURL=variants.js.map
